import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const GA_ID = 'G-V4EYVJBPS8';

/**
 * Load and fire GA4 only on public pages. Authenticated portal routes
 * (which contain Firestore document IDs) are never tracked.
 */
const PUBLIC_PATHS = ['/', '/about', '/services', '/contact', '/register', '/book', '/patient-info', '/refer', '/privacy-policy', '/login'];

let scriptLoaded = false;

function loadGtagScript() {
  if (scriptLoaded) return;
  scriptLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: unknown[]) { window.dataLayer.push(args); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function usePublicAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const isPublic = PUBLIC_PATHS.includes(location.pathname);
    if (!isPublic) return;

    loadGtagScript();

    const gtag = window.gtag;
    if (gtag) {
      gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location.pathname]);
}
